/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RemoveShipmentDocumentRequest
 */
export interface RemoveShipmentDocumentRequest {
    /**
     * 
     * @type {string}
     * @memberof RemoveShipmentDocumentRequest
     */
    documentId: string;
}

/**
 * Check if a given object implements the RemoveShipmentDocumentRequest interface.
 */
export function instanceOfRemoveShipmentDocumentRequest(value: object): value is RemoveShipmentDocumentRequest {
    if (!('documentId' in value) || value['documentId'] === undefined) return false;
    return true;
}

export function RemoveShipmentDocumentRequestFromJSON(json: any): RemoveShipmentDocumentRequest {
    return RemoveShipmentDocumentRequestFromJSONTyped(json, false);
}

export function RemoveShipmentDocumentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemoveShipmentDocumentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'documentId': json['documentId'],
    };
}

  export function RemoveShipmentDocumentRequestToJSON(json: any): RemoveShipmentDocumentRequest {
      return RemoveShipmentDocumentRequestToJSONTyped(json, false);
  }

  export function RemoveShipmentDocumentRequestToJSONTyped(value?: RemoveShipmentDocumentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documentId': value['documentId'],
    };
}

